import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/about',
    label: 'About Us'
  }, {
    path: '/services',
    label: 'Services'
  }, {
    path: '/treatments',
    label: 'Treatments'
  }, {
    path: '/education',
    label: 'Education'
  }, {
    path: '/blog',
    label: 'Blog'
  }, {
    path: '/resources',
    label: 'Resources'
  }, {
    path: '/faqs',
    label: 'FAQs'
  }, {
    path: '/contact',
    label: 'Contact'
  }];
  return <nav className="bg-white shadow-md sticky top-0 z-50 w-full" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="flex justify-between items-center h-20" data-id="element-84">
          <Link to="/" className="flex items-center space-x-3" data-id="element-85">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8eURTgVqvsP8mr9gqSQeVQ/Logos.png" alt="AETHE Logo" className="h-16 w-16 object-contain" data-id="element-86" />
            <div data-id="element-87">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-88">AETHE.IN</h1>
              <p className="text-xs text-gray-600" data-id="element-89">Integrative Medicine</p>
            </div>
          </Link>
          <div className="hidden lg:flex items-center space-x-1" data-id="element-90">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === link.path ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'}`} data-id="element-91">
                {link.label}
              </Link>)}
          </div>
          <div className="hidden lg:flex items-center space-x-4" data-id="element-92">
            <a href="tel:+918303699990" className="flex items-center text-gray-700 hover:text-blue-600" data-id="element-93">
              <PhoneIcon className="w-4 h-4 mr-2" data-id="element-94" />
              <span className="text-sm font-medium" data-id="element-95">+91 83036 99990</span>
            </a>
            <button className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-96">
              Book Appointment
            </button>
          </div>
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100" data-id="element-97">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-98" /> : <MenuIcon className="w-6 h-6" data-id="element-99" />}
          </button>
        </div>
      </div>
      {isOpen && <div className="lg:hidden bg-white border-t" data-id="element-100">
          <div className="px-4 py-4 space-y-2" data-id="element-101">
            {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`block px-4 py-2 rounded-md text-sm font-medium ${location.pathname === link.path ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-102">
                {link.label}
              </Link>)}
            <button className="w-full bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 mt-4" data-id="element-103">
              Book Appointment
            </button>
          </div>
        </div>}
    </nav>;
}